import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/svg/logoIcon";
import BackButton from "./backButton";
import ChatHistory from "./chatHistory";
import Footer from "./footer";
import PaginationControls from "./adminTables/paginationControls";
import { Alert as AlertType } from "../../utils/interfaces";
import Alert from "./alerts/alert";

interface AdminLayoutProps {
  title: string;
  children: ReactNode;
  actionPanel?: ReactNode;
  formData: { results: any[]; total_count: number };
  currentPage: number;
  setCurrentPage: (page: number) => void;
  itemsPerPage: number;
  setItemsPerPage: (items: number) => void;
  alert?: AlertType;
  setAlert?: (alert: AlertType | null) => void;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  title,
  children,
  actionPanel,
  formData,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
  alert,
  setAlert,
}) => {
  const navigate = useNavigate();
  const maxPages = Math.ceil(formData.total_count / itemsPerPage);

  return (
    <section className="authentication" style={{ height: "90vh" }}>
      <div className="row align-items-center justify-content-center min-vh-90 w-100">
        <div
          className="col-md-10 col-lg-10 col-xl-12 align-self-center"
          style={{ overflow: "hidden" }}
        >
          <div
            className="card mx-auto text-center mt-5 overflow-auto min-vh-80 max-vh-80"
            style={{ overflow: "auto" }}
          >
            <div
              className="card-body"
              style={{
                paddingLeft: "1%",
                paddingRight: "1%",
                overflow: "auto",
                minHeight: "70vh",
                maxHeight: "80vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div className="mb-3">
                <LogoIcon />
              </div>
              <div>
                <h2 className="my-1 my-md-1">{title}</h2>
                <div className="mt-2 mb-10 d-flex justify-content-end align-self-end align-items-end">
                  <div
                    className="w-10 d-flex flex-column gap-1 text-start "
                    style={{ width: "20%", height: actionPanel ? "6em" : "auto" }}
                  >
                    {actionPanel}
                  </div>
                </div>
              </div>
              <div className="flex-grow-1">
                <div className="mt-10">
                  {children}
                </div>
              </div>
              <PaginationControls
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                maxPages={maxPages}
                formData={formData}
              />
              <div className="mb-3">
                <BackButton />
              </div>
              {alert && setAlert && (
                <Alert
                  message={alert.message}
                  type={alert.type}
                  show={alert.show}
                  onClose={() => setAlert({ ...alert, show: false })}
                />
              )}
            </div>
          </div>
        </div>
        <Footer />
        <ChatHistory
          onNavigate={(path: string) => {
            navigate(path);
          }}
        />
      </div>
    </section>
  );
};

export default AdminLayout; 